require('whatwg-fetch');

/* istanbul ignore if */
if (!process.env.REACT_APP_MICRO_SERVICE) {
  require('./StandaloneApp/standalone');
}
/* istanbul ignore if */
if (process.env.NODE_ENV === 'production') {
  // production mode has mini-css-extract-plugin generate a main.css file that we should inject
  // eslint-disable-next-line import/no-webpack-loader-syntax
  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = (global.__webpack_events_public_path__ || global.__webpack_public_path__) + '/static/css/main.css';
  const target = document.querySelector('head');
  target.appendChild(link);
}

export default require('./EmbedFramework');
